import * as React from 'react';

class ApplicantLinkBlock extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      applicantId: undefined,
    };
    this.fetchApplicantId();
  }

  fetchApplicantId() {
    $.ajax({
      url: `/sumsub/${this.props.externalUUID}/sumsub-applicant-id`,
      dataType: "json",
      type: "GET",
    }).done((response) => {
      if (response.status === 200) {
        this.setState({
          applicantId: response.data.applicant_id,
        });
      }
    });
  }

  render() {
    const link = `https://cockpit.sumsub.com/checkus#/applicant/${this.state.applicantId}`;
    return (
      <p>
        {this.state.applicantId ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            Sumsub applicant for this entity
          </a>
        ) : (
          <span>No Sumsub applicant for this entity</span>
        )}
      </p>
    );
  }
}

module.exports = {
  ApplicantLinkBlock,
};
